// extracted by mini-css-extract-plugin
export default {"body":"Furnace-module__body-EePPYy","image":"Furnace-module__image-Oiyc8b"};